import { render, staticRenderFns } from "./contactBox.vue?vue&type=template&id=62b7e1bb&"
import script from "./contactBox.vue?vue&type=script&lang=ts&"
export * from "./contactBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports